import { PageTitle } from '_metronic/layout/core'

import KumopackNumericStepper from 'Presentation/Components/KumopackStepperNumeric'
import NumberBox from 'Presentation/Components/Statistics/NumberBox'
import TotalSaleChart from './Components/TotalSale/View'
import { ClientSideTable } from 'Presentation/Components/Table'

import useViewModel from './ViewModel'

//////////
// View //
//////////

const DashboardPage = () => {
	const { steppers, data, reportData, TAB_CONFIGS } = useViewModel()

	return (
		<ViewPageTitle>
			<div className="row gy-5">
				{/* Stepper */}
				<div className="col-12">
					<div className="card border border-kumopack-grey-200">
						<div className="card-body">
							<KumopackNumericStepper items={steppers} />
						</div>
					</div>
				</div>

				{/* Amount of Requesting Quotation */}
				<div className="col-12 col-xl-6">
					<NumberBox
						name="amountOfQoRequest"
						title="จำนวนการขอใบเสนอราคาใหม่"
						toolTip="amountOfQoRequest"
						unit="คำขอ"
						unitTooltip="คำขอ"
						value={reportData?.stat?.countNewQuotations ?? 0}
						valueChangePercentage={1.3}
						hideTrend
					/>
				</div>

				{/* Total Orders */}
				<div className="col-12 col-xl-6">
					<NumberBox
						name="totalOrders"
						title="จำนวนคำสั่งซื้อ"
						toolTip="totalOrders"
						unit="คำสั่งซื้อ"
						unitTooltip="คำสั่งซื้อ"
						value={reportData?.stat?.totalTransaction ?? 0}
						valueChangePercentage={1.3}
						hideTrend
					/>
				</div>

				{/* Sales This Month */}
				<div className="col-12 col-xl-6">
					<NumberBox
						name="salesThisMonth"
						title="ยอดขายเดือนปัจจุบัน"
						toolTip="salesThisMonth"
						unit="บาท"
						unitTooltip="บาท"
						value={reportData?.stat?.thisMonthSaleReport?.oem ?? 0}
						valueChangePercentage={25.7}
						hideTrend
					/>
				</div>

				{/* Customers */}
				<div className="col-12 col-xl-6">
					<NumberBox
						name="customers"
						title="จำนวนลูกค้าในระบบ"
						toolTip="customers"
						unit="คน"
						unitTooltip="คน"
						value={reportData?.stat?.totalCustomer ?? 0}
						valueChangePercentage={-2}
						hideTrend
					/>
				</div>

				{/* Total Sales */}
				<div className="col-12">
					<TotalSaleChart />
				</div>

				{/* Customers Table */}
				<div className="col-12">
					<div className="card border border-kumopack-grey-200">
						<div className="card-header mt-4">
							<div className="card-title">
								{/* Title */}
								<div>
									<h4 className="text-kumopack-grey-900 fw-bold mb-2">
										Customers{' '}
										<span className="badge badge-kumopack-secondary-100 text-kumopack-secondary-700 border-radius-16px fw-normal ms-2">
											{data?.length} members
										</span>
									</h4>
									<div className="text-kumopack-grey-600 fs-6">
										Manage your team members and their account permissions here.
									</div>
								</div>
							</div>

							{/* <div className="card-toolbar">
								<button className="btn btn-sm btn-kumopack-secondary-600 text-kumopack-base-white fw-bold">
									Export
								</button>
							</div> */}
						</div>

						<div className="card-body px-0">
							<ClientSideTable pagination items_per_page={10} columns={TAB_CONFIGS} data={data} />
						</div>
					</div>
				</div>
			</div>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: 'Dashboards',
						path: '/dashboard',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'OEM',
						path: '/dashboard/oem',
						isActive: true,
						isSeparator: false,
					},
				]}>
				OEM Dashboard
			</PageTitle>

			{children}
		</>
	)
}

export default DashboardPage
